<form [formGroup]="detailsForm">
  <!-- Fila 1: Tipo venta + Código modelo (col-6), Código descuento (col-12). Desktop: 3x col-4 -->
  <div class="row">
     <div class="col-6 col-xl-4 mb-3">
        <label for="supplier_sale_type" class="form-label">{{
          "inputs.supplier_sale_type" | translate
          }}</label>
        <div class="input-group">
          <input type="text" class="form-control" id="supplier_sale_type" required
            formControlName="supplier_sale_type" placeholder="{{
              'inputs.supplier_sale_type' | translate
            }}" />
        </div>
      </div>
      <div class="col-6 col-xl-4 mb-3">
        <label for="vehicle_model_code" class="form-label">{{
          "inputs.vehicle_model_code" | translate
          }}</label>
        <div class="input-group">
          <input type="text" class="form-control" id="vehicle_model_code" required formControlName="vehicle_model_code"
            placeholder="{{
              'inputs.vehicle_model_code' | translate
            }}" />
        </div>
      </div>

      <div class="col-12 col-xl-4 mb-3">
        <label for="vehicle_discount_code" class="form-label">{{
          "inputs.vehicle_discount_code" | translate
          }}</label>
        <div class="input-group">
          <input type="text" class="form-control" id="vehicle_discount_code" required
            formControlName="vehicle_discount_code" placeholder="{{
              'inputs.vehicle_discount_code' | translate
            }}" />
        </div>
      </div>
    </div>

    <div class="row linea"></div>
    <!-- Fila 2: Concesión (col-12), Fechas (col-6 + col-6). Desktop: 3x col-4 -->
    <div class="row d-flex align-items-end">
      <div class="col-12 col-xl-4 mb-3">
        <label for="dealership" class="form-label">{{
          "inputs.dealership" | translate
          }}</label>
        <span class="info-icon" tabindex="0">
          <i class="icon-notification"></i>
          <span class="tooltip">{{
            'inputs.i.dealership' | translate
            }}</span>
        </span>
        <ng-select formControlName="dealership_id" [items]="dealershipData" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.dealership' | translate" [searchable]="true" [clearable]="false"
          [notFoundText]="'tables.no_results' | translate">
        </ng-select>
      </div>
      <div class="col-6 col-xl-4 mb-3">
        <label for="vehicle_billing_date" class="form-label">{{ "inputs.vehicle_billing_date"
          | translate
          }}</label>
        <span class="info-icon" tabindex="0">
          <i class="icon-notification"></i>
          <span class="tooltip">{{
            'inputs.i.vehicle_billing_date' | translate
            }}</span>
        </span>
        <div class="input-group">
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="vehicle_billing_date" formControlName="vehicle_billing_date" placeholder="{{
                'inputs.vehicle_billing_date' | translate
              }}" />
            <mat-datepicker-toggle matSuffix [for]="vehicle_billing_date"></mat-datepicker-toggle>
            <mat-datepicker #vehicle_billing_date></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6 col-xl-4 mb-3">
        <label for="vehicle_payment_date" class="form-label">{{ "inputs.vehicle_payment_date"
          | translate
          }}</label>
        <span class="info-icon" tabindex="0">
          <i class="icon-notification"></i>
          <span class="tooltip">{{
            'inputs.i.vehicle_payment_date' | translate
            }}</span>
        </span>
        <div class="input-group">
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="vehicle_payment_date" formControlName="vehicle_payment_date" placeholder="{{
                'inputs.vehicle_payment_date' | translate
              }}" />
            <mat-datepicker-toggle matSuffix [for]="vehicle_payment_date"></mat-datepicker-toggle>
            <mat-datepicker #vehicle_payment_date></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row linea"></div>
    <div class="tabs" [ngClass]="{ 'private-background': activeTab === 'definitive' }">
      <div class="tab-buttons">
        <button class="tab-button" (click)="setActiveTab('original')"
          [ngClass]="{ 'active': activeTab === 'original' }">
          {{"inputs.original" | translate}}
        </button>
        <button class="tab-button" (click)="setActiveTab('definitive')"
          [ngClass]="{ 'active': activeTab === 'definitive' }">
          {{"inputs.definitive" | translate}}
        </button>
      </div>
    </div>

    <div *ngIf="activeTab=='original'">
      <div class="row details">
        <div class="col-5">
        </div>
        <div class="col-6 d-flex justify-content-end">
          <span class='detail_value'>{{ ("inputs.import") | translate }}</span>
        </div>
      </div>

      <div class="row details" *ngFor="let campo of camposFactura_pre">
        <div *ngIf="campo == 'vehicle_invoice_pre_total_amount'">
          <div class="row linea-details"></div>
          <div class="row">
            <div class="col-5">
              <span class="detail_type fw-bold">{{ ("inputs.vehicle_invoice_pre_discount") | translate }} (
                {{detailsForm.get('vehicle_invoice_pre_discount_pctg')?.value}} % )</span>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <span class='detail_value'>{{ detailsForm.get('vehicle_invoice_pre_discount')?.value }} €</span>
            </div>
          </div>
          <div class="row linea-details"></div>
          <div class="row">
            <div class="col-5">
              <span class="detail_type fw-bold">{{ ("inputs.vehicle_invoice_pre_transport") | translate }} (
                {{detailsForm.get('vehicle_invoice_pre_transport_discount_pctg')?.value}} % )</span>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <span class='detail_value'>{{ detailsForm.get('vehicle_invoice_pre_transport')?.value }} €</span>
            </div>
          </div>
          <div class="row linea-details"></div>
          <div class="row">
            <div class="col-5">
              <span class="detail_type fw-bold">{{ ("inputs.vehicle_invoice_pre_tax") | translate }} (
                {{detailsForm.get('vehicle_invoice_pre_tax')?.value}} % )</span>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <span class='detail_value'>{{ detailsForm.get('vehicle_invoice_pre_tax_amount')?.value }} €</span>
            </div>
          </div>
        </div>
        <div *ngIf="!camposJson.includes(campo)">
          <div class="row linea-details"></div>
          <div class="row">
            <div class="col-5">
              <span class="detail_type fw-bold">{{ ("inputs." + campo) | translate }}</span>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <span class='detail_value'>{{ detailsForm.get(campo)?.value > 0 ? detailsForm.get(campo)?.value : '0' }}
                €</span>
            </div>
          </div>
        </div>

        <div *ngIf="camposJson.includes(campo)">
          <div class="row">
            <div class="offset-1 col-10 d-flex flex-column" *ngIf="detailsForm.get(campo)?.value.length">
              <div class="d-flex justify-content-between" *ngFor="let option of detailsForm.get(campo)?.value">
                <span>{{ option.name }}</span>
                <span>{{ option.amount > 0 ? option.amount : '0' }} € </span>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div *ngIf="activeTab=='definitive'">
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_vehicle") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_vehicle" type="text" />
          <span> € </span>
        </div>
      </div>
      <!--    <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_packs") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_packs" type="text" />
          <span> € </span>
        </div>
      </div>
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_packs_detail") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_packs_detail" type="text" />
          <span> € </span>
        </div>
      </div> -->
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_packs") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <!-- <button class="btn btn-primary" (click)="addToFormArray('vehicle_invoice_packs_detail')">{{
            ("inputs.add_option") | translate }}</button> -->
            <button class="btn" [ngClass]="isFieldReadOnly('vehicle_invoice_packs_detail') ? 'btn-disabled' : 'btn-primary'"
              [disabled]="isFieldReadOnly('vehicle_invoice_packs_detail')" (click)="addToFormArray('vehicle_invoice_packs_detail')">
              {{ ("inputs.add_option") | translate }}
            </button>
        </div>
      </div>
      <div formArrayName="vehicle_invoice_packs_detail">
        <div *ngFor="let option of packDetailArray.controls; let i = index" [formGroupName]="i"
          class="row details definitive-background">
          <div class="col-2 d-flex align-items-center">
            <span class="detail_type">{{ i + 1 }}-</span>
          </div>
          <div class="col-10 d-flex justify-content-between align-items-center">
            <input class="detail_value" formControlName="name" type="text" placeholder="Nombre" />
            <input class="detail_value" formControlName="amount" type="text" placeholder="Importe" />
            <span>€</span>
            <i class="btn icon-trash" (click)="removeFromFormArray(i,'vehicle_invoice_packs_detail')">
            </i>
          </div>

        </div>
      </div>

      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_options") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <!-- <button class="btn btn-primary" (click)="addToFormArray('vehicle_invoice_options_detail')">{{
            ("inputs.add_option") | translate }}</button> -->
            <button class="btn" [ngClass]="isFieldReadOnly('vehicle_invoice_options_detail') ? 'btn-disabled' : 'btn-primary'"
              [disabled]="isFieldReadOnly('vehicle_invoice_options_detail')"
              (click)="addToFormArray('vehicle_invoice_options_detail')">
              {{ ("inputs.add_option") | translate }}
            </button>
        </div>
      </div>
      <div formArrayName="vehicle_invoice_options_detail">
        <div *ngFor="let option of optionsDetailArray.controls; let i = index" [formGroupName]="i"
          class="row details definitive-background">
          <div class="col-2">
            <span class="detail_type">{{ i + 1 }}-</span>
          </div>
          <div class="col-10 d-flex justify-content-end align-items-center">
            <input class="detail_value" formControlName="name" type="text" placeholder="Nombre" />
            <input class="detail_value" formControlName="amount" type="text" placeholder="Importe" />
            <span> € </span>
            <i class="btn icon-trash" (click)="removeFromFormArray(i,'vehicle_invoice_options_detail')">
            </i>
          </div>
        </div>
      </div>


      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_promotion") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_promotion" type="text" />
          <span> € </span>
        </div>
      </div>

      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_accessories") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <!-- <button class="btn btn-primary" (click)="addToFormArray('vehicle_invoice_accessories_detail')">{{
            ("inputs.add_option") | translate }}</button> -->
            <button class="btn" [ngClass]="isFieldReadOnly('vehicle_invoice_accessories_detail') ? 'btn-disabled' : 'btn-primary'"
              [disabled]="isFieldReadOnly('vehicle_invoice_accessories_detail')"
              (click)="addToFormArray('vehicle_invoice_accessories_detail')">
              {{ ("inputs.add_option") | translate }}
            </button>
        </div>
      </div>
      <div formArrayName="vehicle_invoice_accessories_detail">
        <div *ngFor="let option of accessoriesDetailArray.controls; let i = index" [formGroupName]="i"
          class="row details definitive-background">
          <div class="col-2">
            <span class="detail_type">{{ i + 1 }}-</span>
          </div>
          <div class="col-10 d-flex justify-content-end align-items-center">
            <input class="detail_value" formControlName="name" type="text" placeholder="Nombre" />
            <input class="detail_value" formControlName="amount" type="text" placeholder="Importe" />
            <span> € </span>
            <i class="btn icon-trash" (click)="removeFromFormArray(i,'vehicle_invoice_accessories_detail')">
            </i>
          </div>
        </div>
      </div>


      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_base_amount") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_base_amount" type="text" />
          <span> € </span>
        </div>
      </div>
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_discount") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_discount_pctg" type="text" />
          <span> % </span>
          <input class='detail_value' formControlName="vehicle_invoice_discount" type="text" />
          <span> € </span>
        </div>
      </div>
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_transport") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_transport_discount_pctg" type="text" />
          <span> % </span>
          <input class='detail_value' formControlName="vehicle_invoice_transport" type="text" />
          <span> € </span>
        </div>
      </div>
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_tax") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value' formControlName="vehicle_invoice_tax" type="text" />
          <span> % </span>
          <input class='detail_value' formControlName="vehicle_invoice_tax_amount" type="text" />
          <span> € </span>
        </div>
      </div>
      <div class="row details definitive-background">
        <div class="col-6">
          <span class="detail_type">{{ ("inputs.vehicle_invoice_total_amount") | translate }}</span>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <input class='detail_value ' formControlName="vehicle_invoice_total_amount" type="text" />
          <span> € </span>
        </div>
      </div>
    </div>
</form>
